<template>
  <div class="settings-panel">
    <!--<GroupSettings
      v-if="activeGroup !== null"
      @group-updated="updateGroup"
    />-->
    <TextSettings
      v-if="ElementCaseNumber === 0 && internalValue"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
      @update-setting="updateSetting"
      @element-updated="$emit('element-updated', $event)"
    />
    <ImageSettings
      v-else-if="ElementCaseNumber === 1 && internalValue"
      :internal-value="internalValue"
      @update:internal-value="onInternalValueUpdate"
    />
    <ButtonSettings
      v-else-if="ElementCaseNumber === 2 && internalValue"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
    />
    <IconSettings
      v-else-if="ElementCaseNumber === 3"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
    />
    <DivSettings
      v-else-if="ElementCaseNumber === 4"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
    />
    <AnimationSettings
      v-else-if="ElementCaseNumber === 5"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
    />
    <ListSettings
      v-else-if="ElementCaseNumber === 6"
      :internal-value="internalValue"
      @update:internal-value="internalValue = $event"
    />
    <BaseSettings
      v-else-if="ElementCaseNumber === null"
      :selected-color="selectedColor"
      :selected-font-local="selectedFontLocal"
      @update:selected-color="selectedColor = $event"
      @update:selected-font-local="selectedFontLocal = $event"
    />
  </div>
</template>

<script>
import TextSettings from "./components/TextSettings.vue";
import ImageSettings from "./components/ImageSettings.vue";
import BaseSettings from "./components/BaseSettings.vue";
import ButtonSettings from "./components/ButtonSettings.vue";
import GroupSettings from "./components/GroupSettings.vue";
import IconSettings from "./components/IconSettings.vue"
import AnimationSettings from "./components/AnimationSettings.vue"
import DivSettings from "./components/DivSettings.vue"
import ListSettings from "./components/ListSettings.vue"
import { safeClone } from '@/utils/clone.js';

export default {
  name: "ElementController",
  components: { TextSettings, ImageSettings, BaseSettings, ButtonSettings, GroupSettings, IconSettings, DivSettings, AnimationSettings, ListSettings },
  data() {
    const fonts = this.$store.getters["landing/landingSettings"].fonts || [];
    return {
      selectedFontLocal: fonts[0] || {},
      internalValue: null,
      ElementCaseNumber: null,
      selectedColor: "transparent"
    };
  },
  computed: {
    activeElement() {
      return this.$store.getters["activeElement/activeElement"];
    },
    activeGroup() {
      return this.$store.getters["activeElement/activeGroup"];
    }
  },
  watch: {
    activeElement: {
      handler(newActiveElement) {
        if (newActiveElement) this.internalValue = safeClone(newActiveElement);
        else this.internalValue = null;

        const textTags = ["h1","h2","h3","h4","p","a","span","li","label"];
        const uploadTags = ["img","file","picture"];
        const buttonTags = ["button","btn"];
        const iconTags = ["i"]
        const divTags = ["div"]
        const tag = newActiveElement?.tag ? String(newActiveElement.tag).toLowerCase() : null;
        const hasBackgroundImage = !!(newActiveElement?.settings?.backgroundImage);
        const hasAnimationSetting = newActiveElement?.settings?.hasOwnProperty('animation')
        const hasAnimationListSetting = newActiveElement?.settings?.animation?.name == 'list'

        this.ElementCaseNumber =
          textTags.includes(tag) ? 0 :
          uploadTags.includes(tag) ? 1 :
          buttonTags.includes(tag) ? 2 :
          iconTags.includes(tag) ? 3 :
          hasAnimationListSetting ? 6 :
          hasAnimationSetting ? 5 :
          hasBackgroundImage ? 1 :
          divTags.includes(tag) ? 4 :
          null;
        if (this.internalValue?.settings?.font && this.internalValue.settings.font.family) {
          try {
            const { loadFontOnce } = require('@/utils/font-loader.js');
            if (typeof loadFontOnce === 'function') loadFontOnce({ fontObj: this.internalValue.settings.font }).catch(()=>{});
          } catch (e) {}
        }
      },
      immediate: true
    },

    internalValue: {
      handler: async function(newVal) {
        if (!this.activeElement) return;

        const canonical = this.findElementByIdInStore(this.activeElement.id);
        if (!canonical) {
          await this.$store.dispatch("landing/UPDATE_ELEMENT", newVal);
          this.$emit("element-updated", newVal);
          return;
        }

        try {
          const newJson = JSON.stringify(newVal || {});
          const canonicalJson = JSON.stringify(canonical || {});
          if (newJson === canonicalJson) return;
        } catch (e) {}

        const toSave = safeClone(newVal);
        await this.$store.dispatch("landing/UPDATE_ELEMENT", toSave);

        const latestCanonical = this.findElementByIdInStore(toSave.id) || toSave;
        if (this.activeElement?.id === toSave.id) {
          this.$store.dispatch("activeElement/UPDATE_ACTIVE_ELEMENT", latestCanonical);
        }

        this.$emit("element-updated", latestCanonical);
      },
      deep: true
    }
  },
  methods: {
    findElementByIdInStore(id) {
      if (!id) return null;
      const landing = this.$store.getters['landing/landing'] || [];
      function find(arr) {
        if (!Array.isArray(arr)) return null;
        for (let item of arr) {
          if (!item) continue;
          if (item.id === id) return item;
          if (item.children?.data) {
            const found = find(item.children.data);
            if (found) return found;
          }
          if (Array.isArray(item.data)) {
            const found = find(item.data);
            if (found) return found;
          }
          if (Array.isArray(item.list)) {
            const found = find(item.list);
            if (found) return found;
          }
        }
        return null;
      }
      return find(landing);
    },

    async onInternalValueUpdate(payload) {
      if (!payload?.id) return;
      const toSave = safeClone(payload);
      await this.$store.dispatch("landing/UPDATE_ELEMENT", toSave);
      const latestCanonical = this.findElementByIdInStore(toSave.id) || toSave;
      if (this.activeElement?.id === toSave.id) {
        this.$store.dispatch("activeElement/UPDATE_ACTIVE_ELEMENT", latestCanonical);
      }
      this.internalValue = safeClone(latestCanonical);
      this.$emit("element-updated", latestCanonical);
    },

    updateSetting(key, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (value === null || value === undefined) delete newVal.settings[key];
      else newVal.settings[key] = value;
      this.internalValue = newVal;
    },

    updateGroup(updatedGroup) {
      this.$store.dispatch("landing/UPDATE_GROUP", updatedGroup);
    }
  }
};
</script>


<style scoped>
.settings-panel__container { 
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0.5rem;
  overflow-y: scroll;
  padding-bottom: 5rem;
}
.settings-panel {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  overflow: hidden;
  max-height: 100%;
}
</style>